<template>
  <div id="Myjob">
    <SidebarAdmin
      :setmyjob="myjob.length"
      :setpacking="packing"
      :orders="jobs"
      :setready="ready"
    />
    <div class="space"></div>
    <p class="myjob"></p>
    <div class="space"></div>
    <div class="container">
      <div
        class="col-md-12 col-sm-12 col-xs-12 col-sm-offset-12 col-xs-offset-12"
      >
        <div v-for="(item, index) of myjob" :key="index">
          <div
            class="card card-order-list card-margin border-light shadow"
            v-if="item.order_status !== 3"
          >
            <div class="card-body">
              <h5 class="card-title">ออร์เดอร์ที่ {{ item.order_code }}</h5>
              <div class="card-content-more" v-if="!orderMore[item.order_id]">
                <p
                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                  data-position="bottom"
                  data-delay="50"
                  data-tooltip="Add to favorites"
                  v-if="!orderMore[item.order_id]"
                  @click="orderShowMore(item.order_id)"
                >
                  <i class="fas fa-chevron-circle-down fa-2x"></i>
                  <!-- <i class="fas fa-ellipsis-h"></i> -->
                </p>
              </div>
              <div class="card-content-more" v-if="orderMore[item.order_id]">
                <p
                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                  data-position="bottom"
                  data-delay="50"
                  data-tooltip="Add to favorites"
                  v-if="orderMore[item.order_id]"
                  @click="orderShowLess(item.order_id)"
                >
                  <i class="fas fa-chevron-circle-up fa-2x"></i>
                  <!-- <i class="fas fa-ellipsis-v"></i> -->
                </p>
              </div>

              <!-- ######################## -->

              <main class="pt-1" v-if="orderMore[item.order_id]">
                <div
                  class="col-md-12 col-sm-12 col-xs-12 col-sm-offset-12 col-xs-offset-12"
                  v-for="(prod, j) of item.order_detail"
                  :key="j"
                >
                  <div
                    class="card flex-md-row mb-4 border-light shadow-sm h-md-250"
                    id="crad-media-size"
                  >
                    <img
                      class="card-img-left flex-auto d-md-block zoom"
                      :src="
                        'https://smartlibrary.ubru.ac.th/Books/' + prod.img_url
                      "
                      alt="Card image cap"
                      id="cardimg"
                    />
                    <div
                      class="card-body d-flex flex-column align-items-start card-content-add"
                    >
                      <h6
                        class="card-title"
                        v-if="!readMore[prod.order_detail_id]"
                      >
                        <img
                          src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                          alt=""
                          style="width: 20px; height: auto"
                          v-if="prod.trans_status === 0"
                        />
                        <i
                          class="fas fa-check-circle fa-green fa-sm"
                          v-if="prod.trans_status === 1"
                        ></i>
                        <i
                          class="far fa-times-circle fa-sm"
                          style="color: red"
                          v-if="prod.trans_status === 2"
                        ></i>

                        {{ prod.book_title.slice(0, 49) }}
                        <a
                          v-if="
                            !readMore[prod.order_detail_id] &&
                            prod.book_title.length > 49
                          "
                          @click="showMore(prod.order_detail_id)"
                          >[...]</a
                        >
                      </h6>

                      <h6
                        class="card-title"
                        v-if="readMore[prod.order_detail_id]"
                      >
                        <img
                          src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                          alt=""
                          style="width: 20px; height: auto"
                          v-if="prod.trans_status === 0"
                        />
                        <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                        <i
                          class="fas fa-check-circle fa-green fa-sm"
                          v-if="prod.trans_status === 1"
                        ></i>
                        <i
                          class="far fa-times-circle fa-sm"
                          style="color: red"
                          v-if="prod.trans_status === 2"
                        ></i>
                        {{ prod.book_title }}
                        <a
                          v-if="readMore[prod.order_detail_id]"
                          @click="showLess(prod.order_detail_id)"
                          >[ย่อ]</a
                        >
                      </h6>

                      <h6 class="card-title barcode">
                        <i class="fas fa-barcode fa-sm"></i>
                        บาร์โค้ด| {{ prod.barcode }}
                      </h6>

                      <h6 class="card-title barcode">
                        <i class="fas fa-map-marker-alt fa-sm"></i>
                        {{ prod.book_location }}
                      </h6>

                      <h6 class="card-title barcode">
                        <i class="fas fa-layer-group fa-sm"></i> หมวดหมู่ |
                        {{ prod.book_cassification }}
                      </h6>

                      <!-- ======== -->
                    </div>
                  </div>
<!-- Start yes no orders -->
                  <div class="content-status" v-if="prod.trans_status === 0">
                    
                    <button
                      class="btn btn-primary btn-status-item-info"
                      @click="
                        YesOrNo(1, item, prod.order_detail_id, prod.barcode)
                      "
                    >
                      Yes
                    </button>
                    <button
                      class="btn btn-danger btn-status-item-danger"
                      @click="
                        YesOrNo(2, item, prod.order_detail_id, prod.barcode)
                      "
                    >
                      No
                    </button>
                  </div>

                  <!-- ======= -->
                  <div
                    class="card-content-more"
                    v-if="
                      !anthor_barcode[prod.order_detail_id] &&
                      prod.another_barcode.length !== 0
                    "
                  >
                    <p
                      class="btn-floating-changbacode btn-large waves-effect waves-light pink tooltipped"
                      data-position="bottom"
                      data-delay="50"
                      data-tooltip="Add to favorites"
                      v-if="!anthor_barcode[prod.order_detail_id]"
                      @click="anthorBarcodeMore(prod.order_detail_id)"
                    >
                      <button class="btn btn-success">เพิ่มเติม</button>
                      <!-- <i class="fas fa-chevron-circle-down fa-2x"></i> -->
                      <!-- <i class="fas fa-ellipsis-h"></i> -->
                    </p>
                  </div>

                  <div
                    class="card-content-more"
                    v-if="
                      anthor_barcode[prod.order_detail_id] &&
                      prod.another_barcode.length !== 0
                    "
                  >
                    <p
                      class="btn-floating-changbacode btn-large waves-effect waves-light pink tooltipped"
                      data-position="bottom"
                      data-delay="50"
                      data-tooltip="Add to favorites"
                      v-if="anthor_barcode[prod.order_detail_id]"
                      @click="anthorBarcodeLess(prod.order_detail_id)"
                    >
                      <button class="btn btn-warning">ปิด</button>

                      <!-- <i class="fas fa-chevron-circle-up fa-2x"></i> -->
                      <!-- <i class="fas fa-ellipsis-v"></i> -->
                    </p>
                  </div>
                  <!-- end yes no Order -->
                  <div v-if="anthor_barcode[prod.order_detail_id]">
                    <!-- Anathor bacode -->

                    <div v-for="(bacode, k) of prod.another_barcode" :key="k">
                      <!-- {{ bacode.barcode }} -->
                      <div class="card-columns">
                        <div
                          class="card card-order-list card-margin border-light shadow"
                        >
                          <div class="card-body">
                            <h6
                              class="card-title"
                              v-if="!readMore[prod.order_detail_id]"
                            >
                              <img
                                src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                alt=""
                                style="width: 20px; height: auto"
                                v-if="prod.trans_status === 0"
                              />
                              <i
                                class="fas fa-check-circle fa-green fa-sm"
                                v-if="prod.trans_status === 1"
                              ></i>
                              <i
                                class="far fa-times-circle fa-sm"
                                style="color: red"
                                v-if="prod.trans_status === 2"
                              ></i>

                              {{ prod.book_title.slice(0, 49) }}
                              <a
                                v-if="
                                  !readMore[prod.order_detail_id] &&
                                  prod.book_title.length > 49
                                "
                                @click="showMore(prod.order_detail_id)"
                                >[...]</a
                              >
                            </h6>

                            <h6
                              class="card-title"
                              v-if="readMore[prod.order_detail_id]"
                            >
                              <img
                                src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                alt=""
                                style="width: 20px; height: auto"
                                v-if="prod.trans_status === 0"
                              />
                              <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                              <i
                                class="fas fa-check-circle fa-green fa-sm"
                                v-if="prod.trans_status === 1"
                              ></i>
                              <i
                                class="far fa-times-circle fa-sm"
                                style="color: red"
                                v-if="prod.trans_status === 2"
                              ></i>
                              {{ prod.book_title }}
                              <a
                                v-if="readMore[prod.order_detail_id]"
                                @click="showLess(prod.order_detail_id)"
                                >[ย่อ]</a
                              >
                            </h6>
                            <h6 class="card-title barcode">
                              <i class="fas fa-barcode fa-sm"></i>
                              บาร์โค้ด| {{ bacode.barcode }}
                            </h6>
                            <h6 class="card-title barcode">
                              <i class="fas fa-map-marker-alt fa-sm"></i>
                              {{ bacode.book_location }}
                            </h6>
                            <h6 class="card-title barcode">
                              <i class="fas fa-layer-group fa-sm"></i>
                              หมวดหมู่ |
                              {{ bacode.book_cassification }}
                            </h6>

                            <div
                              class="content-status"
                              v-if="prod.trans_status === 0"
                            >
                              <button
                                class="btn btn-primary btn-status-info"
                                @click="
                                  YesOrNo(
                                    1,
                                    item,
                                    prod.order_detail_id,
                                    bacode.barcode
                                  )
                                "
                              >
                                Yes
                              </button>
                              <button
                                class="btn btn-danger btn-status-danger"
                                @click="
                                  YesOrNo(
                                    2,
                                    item,
                                    prod.order_detail_id,
                                    bacode.barcode
                                  )
                                "
                              >
                                No
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- end -->
                  </div>
                </div>
              </main>

              <!-- ##################### -->
              <p class="card-text">
                <small class="text-muted">
                  <i class="fas fa-calendar-alt"></i>วันรับ :
                  {{ item.mustbeget_date | moment }}
                  <!-- {{moment(item.mustbeget_date).fromNow()}} -->
                  <i v-if="item.order_status === 1">
                    <img
                      src="../../assets/icons/alram.gif"
                      alt=""
                      style="width: 23px; height: auto"
                    />
                    รีบดำเนินการ
                  </i>

                  <i v-if="item.order_status === 2">
                    <img
                      src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"
                      alt=""
                      style="width: 15px; height: auto"
                    />
                    กำลังดำเนินการ
                  </i>
                </small>
              </p>
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarAdmin from "../layouts/sidbar-admin.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: { SidebarAdmin },
  name: "Myjob",
  data() {
    return {
      myjob: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      isLoading: false,
      readMore: {},
      show: false,
      orderMore: {},
      bar: "",
      orderStatus: false,
      Sorder: "",
      s: "",
      jobs: [],
      packing: [],
      ready: [],
      code: "",
      anthor_barcode: {},
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("LL");
    },
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    this.getmyjob();
  },
  methods: {
    moment: function () {
      return moment();
    },
    YesOrNo(status, item, id, newbarcode) {
      for (var i in item.order_detail) {
        if (item.order_detail[i].order_detail_id === id) {
          item.order_detail[i].trans_status = status;
          this.bar = item.order_detail[i].barcode;
          this.myjob.push(item);
          const seen = new Set();
          this.myjob = this.myjob.filter((el) => {
            const duplicate = seen.has(el.order_code);
            seen.add(el.order_code);
            return !duplicate;
          });
        }
      }
      let IP = localStorage.getItem("IP");
      let data = {
        token: this.token,
        order_code: item.order_code,
        staff_code: this.code,
        trans_status: status,
        public_ip: IP,
        barcode: this.bar,
        new_barcode: newbarcode,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_trans_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log("get y or n",res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
            this.getmyjob();
          } else {
            if (item.order_code === res.data.Orders[0].order_code) {
              if (res.data.Orders[0].order_status === 3) {
                this.myjob.splice(this.myjob.indexOf(item), 1);
                this.packing = res.data.dasboard[0].packing;
                this.jobs = res.data.dasboard[0].neworders;
                this.ready = res.data.dasboard[0].ready;
              }
            }
          }
        });
    },
    getmyjob() {
      let data = {
        token: this.token,
        order_status: 1,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_myjob", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            this.$isLoading(false);
            alert(res.data.msg.message);
          } else {
            this.myjob = res.data.Orders;
            this.$isLoading(false);
            this.s = this.myjob.length;
            this.packing = res.data.dasboard[0].packing;
            this.jobs = res.data.dasboard[0].neworders;
            this.ready = res.data.dasboard[0].ready;
          }
        });
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    orderShowMore(id) {
      this.$set(this.orderMore, id, true);
    },
    orderShowLess(id) {
      this.$set(this.orderMore, id, false);
    },
    anthorBarcodeMore(id) {
      this.$set(this.anthor_barcode, id, true);
    },
    anthorBarcodeLess(id) {
      this.$set(this.anthor_barcode, id, false);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  .myjob:before {
    content: "Myjob";
    background-color: coral;
    width: 100px;
    height: 40px;
    z-index: 1030;
    font-size: 20px;
    /* border-radius: 60%; */
    color: white;
    padding: 5px;

    position: fixed;
    /* top: 360px; */
    right: 0px;
  }
}

.myjob-content {
  position: relative;
  right: 170px;
}
.card-content-more {
  position: relative;
}
.content-status {
  position: relative;
}
.btn-status-item-info {
  position: absolute;
  top: -70px;
  right: 50px;

  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}
.btn-status-item-danger {
  position: absolute;
  top: -70px;
  right: 0px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}

.btn-status-info {
  position: absolute;
  top: -20px;
  right: 40px;

  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}
.btn-status-danger {
  position: absolute;
  top: -20px;
  right: -18px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}

.btn-floating {
  position: absolute;
  /* width: 46px;
  height: 40px;
  background: rgb(120, 90, 227);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 12px; */
  top: -54px;
  right: -20px;
  /* top: -100px; */
  font-size: 14px;
  color: rgb(79, 159, 0);
}
.content-yes-no {
  position: relative;
  background-color: blue;
}
.btn-content-yes {
  position: absolute;
  margin-left: 100px;
}

.btn-content-no {
  position: absolute;
}
.btn-floating-changbacode {
  position: absolute;
  top: -70px;
  right: 110px;
  /* top: -100px; */
  font-size: 14px;
  color: rgb(79, 159, 0);
}
.fa-green {
  color: rgb(79, 159, 0);
}
.space {
  height: 50px;
}
.space1 {
  height: 3000px;
}
.two {
  height: 1000px;
}
.text-muted i {
  margin: 0 5px;
}

a {
  color: rgba(70, 5, 97, 0.961);
}
a:hover {
  text-decoration: initial;
  color: rgb(90, 5, 187);
}

.card-margin {
  margin-bottom: 1.875rem;
}
.card-order-list {
  padding: 5px;
}
.card-order-list_ {
  padding: 25px;
}
.card-margin-orderlist {
  margin-bottom: 1rem;
}
@media (max-width: 1199px) {
  .btn-floating {
    position: absolute;
    top: -54px;
    right: -20px;
    /* top: -100px; */
    font-size: 14px;
    color: rgb(79, 159, 0);
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
}

.card-content-more {
  position: relative;
}

.fa-purple {
  color: rgb(109, 7, 172);
}
.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 30px;
  bottom: 5px;
}
.barcode {
  margin-left: 25px;
}

img {
  height: 200px;
}

@media screen and (max-width: 576px) {
  img {
    height: 360px;
  }
}

@media screen and (max-width: 767px) {
  img {
    height: 300px;
  }
}

.card-title {
  text-align: left;
  /* text-align: justify; */
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  /* bottom: 5px; */
}

li {
  list-style-type: none;
}
.icon-booking {
  padding: 5px;
}
.side-left {
  position: fixed;
  width: 256px;
}
.txt-sidebar {
  text-align: left;
}
.zoom {
  padding: 25px;
  /* background-color: green; */
  transition: transform 0.2s;
  /* width: 200px;
  height: 200px; */
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Safari 3-8 */
  transform: scale(1.5);
}
.main {
  width: 50%;
  margin: 50px auto;
}
</style>
